(() => {
  'use strict';

  const CARD_FACTOR_12 = 1.1427765535478185;

  const storeCurrency =
    window.themeVariables?.settings?.storeCurrency ||
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    'BRL';

  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
    style: 'currency',
    currency: storeCurrency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const money = (value) => formatter.format(value);

  function parseMoney(text) {
    let value = String(text || '').replace(/\u00a0/g, ' ').replace(/[^0-9,.-]/g, '');
    if (!value) return Number.NaN;

    const comma = value.lastIndexOf(',');
    const dot = value.lastIndexOf('.');

    if (comma > dot) value = value.replace(/\./g, '').replace(',', '.');
    else if (comma > -1 && dot > comma) value = value.replace(/,/g, '');
    else if (comma > -1) value = value.replace(',', '.');

    return Number.parseFloat(value);
  }

  function updatePaymentSummary(root, base) {
    if (!root || !Number.isFinite(base)) return;

    const rows = root.querySelectorAll('[data-installment-row]');
    rows.forEach((row) => {
      const count = Number(row.dataset.installments);
      const installmentFactor = Number(row.dataset.installmentFactor);
      const totalFactor = Number(row.dataset.totalFactor);

      if (!Number.isInteger(count) || count < 1 || count > 12 || !Number.isFinite(installmentFactor)) return;

      const value = row.querySelector('[data-installment-value]');
      const total = row.querySelector('[data-installment-total]');
      const installmentValue = base * installmentFactor / count;

      if (value) value.textContent = money(installmentValue);
      if (total && Number.isFinite(totalFactor)) total.textContent = money(base * totalFactor);
    });

    const row12 = root.querySelector('[data-installment-row][data-installments="12"]');
    const factor12 = Number(row12?.dataset.installmentFactor);
    const maxPrice = root.querySelector('[data-max-installment-price]');
    if (maxPrice && Number.isFinite(factor12)) maxPrice.textContent = money(base * factor12 / 12);

    const pix = root.querySelector('[data-pix-price]');
    if (pix) {
      const discount = Number(root.dataset.pixDiscount || 0);
      pix.textContent = money(base * (1 - discount / 100));
    }
  }

  function updateProductCard(card) {
    if (!card) return;

    const row = card.querySelector('.parcelas-home');
    const salePrice = card.querySelector('price-list sale-price, sale-price');
    const price = parseMoney(salePrice?.textContent);

    if (!row || !Number.isFinite(price)) return;

    const values = row.querySelectorAll('strong');
    if (values.length < 2) return;

    values[0].textContent = '12x';
    values[1].textContent = money(price * CARD_FACTOR_12 / 12);
  }

  document.addEventListener('variant:change', (event) => {
    const cents = Number(event.detail?.variant?.price);
    if (!Number.isFinite(cents)) return;

    const section = event.target?.closest?.('.shopify-section');
    if (!section) return;

    const base = cents / 100;
    section.querySelectorAll('[data-payment-summary]').forEach((root) => {
      updatePaymentSummary(root, base);
    });
  });

  document.addEventListener('change', (event) => {
    const card = event.target.closest?.('product-card');
    if (!card) return;

    requestAnimationFrame(() => updateProductCard(card));
  });
})();
